(function () {
  // ---------- Collection sort ----------
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ---------- Product form ----------
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var idInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add]');
  var note = form.querySelector('[data-note]');
  var sizeLabel = form.querySelector('[data-size-label]');
  var priceEl = document.querySelector('[data-price]');
  var needsSize = addBtn && addBtn.hasAttribute('data-needs-size');
  var chosen = null;
  var labelBase = sizeLabel ? sizeLabel.textContent : '';

  form.querySelectorAll('[data-size-variant]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      chosen = btn.dataset.sizeVariant;
      idInput.value = chosen;
      form.querySelectorAll('[data-size-variant]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      if (sizeLabel) sizeLabel.textContent = labelBase + ' — ' + btn.dataset.sizeName;
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
      addBtn.textContent = 'Add to bag';
      note.textContent = '';
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBtn.disabled) return;
    if (needsSize && !chosen) { note.textContent = 'Select a size'; return; }

    addBtn.disabled = true;
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Could not add to bag');
        addBtn.textContent = 'Added to bag';
        note.innerHTML = '<a class="ul" href="/cart">View bag</a>';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function (err) { note.textContent = err.message; })
      .finally(function () { addBtn.disabled = false; });
  });
})();
